import styled from 'styled-components'

export const Modal = styled.div`
  background: white;
  min-width: 300px;
  max-width: 100vw;
  border-radius: 1px;
  margin: 0 auto;
  border: solid 0.1px rgba(186, 186, 186, 1);

  @media only screen and (min-width: 1090px) {
    width: 50%;
    max-height: 70%;
    border-radius: 13px;
  }
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  h1 {
    margin: 0;
    font-size: 22px;
    font-weight: bolder;
  }
  h2 {
    margin: 12px 0 0 0;
    font-weight: 400;
  }
  button {
    border: none;
    background-color: transparent;
    color: black;
    font-size: 19px;
  }
`

export const TextAnnotation = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-width: 16rem;
  max-width: 80rem;
  word-wrap: break-word;
  padding: 1rem;
  h2 {
    font-size: 17px;
    margin: 1rem 0 0.5rem 0;
    min-width: 12rem;
    max-width: 60rem;
    max-height: 10rem;
  }
  p {
    height: auto;
    overflow-y: auto;
    margin: 0;
    text-align: justify;
    overflow: auto;
    ::-webkit-scrollbar {
      width: 3px;
    }
  }
`

export const ButtonsSend = styled.div`
  display: flex;
  justify-content: end;
  right: 2rem;
  border: none;
  padding: 1rem;
  button {
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
    border: solid 0.1px rgba(186, 186, 186, 1);
    background-color: transparent;
  }
  .back-button {
    border-radius: 5px;
    background-color: #ff6600;
    color: white;
    border: none;
    padding: 10px 20px 10px 20px;
    font-weight: 700;
  }
  @media only screen and (max-width: 800px) {
    display: none;
  }
`
